import { useEffect, useState } from "react";
import { CloseButton } from "react-bootstrap";
import styled from "styled-components";

import useErrorAlert from "../hooks/useErrorAlert";

const Style = {
  Container: styled.div<{ hide: boolean }>`
    color: white;
    padding: 20px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    background-color: #bb2222;
    display: flex;
    transition: transform 250ms ease-in-out;
    ${({ hide }) => hide && `transform: translateY(-100%);`}
    z-index: 1000;
  `,
  Text: styled.div`
    font-size: 14px;
  `,
};

const ErrorPopup = () => {
  const { error } = useErrorAlert();
  const [isErrorHidden, setIsErrorHidden] = useState(false);

  useEffect(() => {
    let t: ReturnType<typeof setTimeout> | undefined = undefined;
    if (error) {
      setIsErrorHidden(false);
      t = setTimeout(() => setIsErrorHidden(true), 10000);
    }
    return () => t && clearTimeout(t);
  }, [error]);

  return error ? (
    <Style.Container hide={isErrorHidden}>
      <Style.Text>
        <strong>{error.title || "There was a problem"}</strong>
        <br />
        {error.message}
      </Style.Text>
      <CloseButton onClick={() => setIsErrorHidden(true)} variant="white" />
    </Style.Container>
  ) : null;
};
export default ErrorPopup;
